import httpService from "@/utils/services/http_service";
const mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

export default {
  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  事件列表
   */
  async eventList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-20
   *  导出事件列表
   */
  async exportEventList(query) {
    let res = await httpService.post('/api.php?do=admin_event_list',
    query);
    console.log(res)
    if (res && res.excel_file_name) {
      let a = document.createElement("a");
      a.href = res.excel_file_name;
      a.download = '事件列表_' + new Date().getTime();
      a.click();
    }
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  事件详情
   */
  async eventDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  添加事件
   */
  async addEvent(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  编辑事件
   */
  async editEvent(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  删除事件
   */
  async deleteEvent(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-03-05
   * 获取事件关联的事件列表
   */
  async getEventRelatedNewsList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_related_news_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  删除采集信息源
   */
  async getEventFieldOptionList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_field_option_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  采集数据信息列表
   */
  async collectDataList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  采集数据信息详情
   */
  async collectDataDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  添加采集数据信息
   */
  async addCollectData(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  编辑采集数据信息
   */
  async editCollectData(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  删除采集数据信息
   */
  // async deleteCollectData(data = {}) {
  //   return httpService.post(
  //     '/api.php?do=admin_catch_data_delete',
  //     data
  //   )
  // },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  采集信息源列表
   */
  async collectSourceList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_config_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  采集信息源详情
   */
  async collectSourceDetail(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_config_info',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  采集数据信息内容翻译
   */
  async collectSourceContentTranslate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_config_info_translate',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  数据采集tag id创建/查询
   */
  async createCollectSourceTag(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_tag_id',
      data
    )
  },

   /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  数据采集tag列表
   */
  async collectSourceTagList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_tag_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  添加采集信息源
   */
  async addCollectSource(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_config_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  编辑采集信息源
   */
  async editCollectSource(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_config_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  删除采集信息源
   */
  async deleteCollectSource(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_config_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  获取采集数据查询条件
   */
  async getCDQueryData(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_query_get',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-16
   *  保存采集数据查询条件
   */
  async saveCDQueryData(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_query_save',
      data
    )
  },

 /**
   * @author: liuxiangmin
   * date: 2020-03-02
   *  国别基础信息库
   */

  // 国家信息列表
   countryInfoList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_country_list',
      data
    )
  },

  // 国家信息 启动/禁用切换
   startupDisable(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_edit',
      data
    )
  },

  // 国家信息创建
   countryInfoCreate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_country_create',
      data
    )
  },

  // 国家信息删除
   countryInfoDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_country_delete',
      data
    )
  },

  // 国家信息修改
   countryInfoEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_country_edit',
      data
    )
  },

  // 国家信息显示
   countryInfoShow(data = {}) {
    return httpService.post(
      '/api.php?do=admin_country_info',
      data
    )
  },

  // 图片上传
  async imageUpload(data = {}) {
    debugger
    return httpService.post(
      '/api.php?do=admin_file_upload',
      data
    )
  },

   /**
   * @author: lafitewu
   * date: 2020-05-27
   *  1.2.1版本
   */
  async batchDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_delete',
      data
    )
  },
  async batchChanel(data = {}) {
    return httpService.post(
      '/api.php?do=admin_catch_data_status',
      data
    )
  },
  async authorList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_list',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-06-15
   *  1.3版本
   */
  async tagList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_tag_list',
      data
    )
  },
  async addTag(data = {}) {
    return httpService.post(
      '/api.php?do=admin_tag_add',
      data
    )
  },
  async tagEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_tag_edit',
      data
    )
  },
  async tagDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_tag_delete',
      data
    )
  },
  async tagBind(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_tag_bind',
      data
    )
  },
  async logInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_log_info',
      data
    )
  },
  async eventLog(data = {}) {
    return httpService.post(
      '/api.php?do=admin_event_log',
      data
    )
  },

  // 1.5新增 国别信息国别指南修改
  async adminGuideEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_country_guide_edit',
      data
    )
  },

  // 安全服务列表
  async servicesList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_secret_service_list',
      data
    )
  },
  async servicesAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_secret_service_create',
      data
    )
  },
  async servicesInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_secret_service_info',
      data
    )
  },
  async servicesEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_secret_service_edit',
      data
    )
  },
  async servicesDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_secret_service_delete',
      data
    )
  },

  async terroristList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_list',
      data
    )
  },
  async terroristInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_info',
      data
    )
  },
  async terroristAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_create',
      data
    )
  },
  async terrorisEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_edit',
      data
    )
  },
  async terrorisDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_delete',
      data
    )
  },

  // 地区列表
  async adminAreaList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_list',
      data
    )
  },

  // 恐怖组织活动范围模块
  async terroristAreaAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_area_create',
      data
    )
  },
  async terroristAreaList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_area_list',
      data
    )
  },
  async terroristAreaDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_terrorist_area_delete',
      data
    )
  },
}
